import { render, staticRenderFns } from "./ZPopover.vue?vue&type=template&id=c4206d88&scoped=true&"
import script from "./ZPopover.vue?vue&type=script&lang=js&"
export * from "./ZPopover.vue?vue&type=script&lang=js&"
import style0 from "./ZPopover.vue?vue&type=style&index=0&id=c4206d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4206d88",
  null
  
)

component.options.__file = "ZPopover.vue"
export default component.exports